import { Link, LinkProps } from 'react-router-dom'
import routes from '~/config/routes'
import { Button } from '~/ui/Button'

export const HomeButton = (props: Omit<LinkProps, 'to'>) => {
  return (
    <Link to={routes.facilities} {...props}>
      <Button>Go home</Button>
    </Link>
  )
}
